import { API } from 'src/utils/config'

// What adomik_api says about its Cognito login (GET /auth/cognito/config.json).
export interface CognitoConfig {
  enabled: boolean
  // Why the last Cognito sign-in was refused. Handed over once.
  error: string | null
  // Cognito's sign-out, returning to this console's login page.
  logout_url: string | null
}

export const COGNITO_OFF: CognitoConfig = { enabled: false, error: null, logout_url: null }

const BACK_FROM_COGNITO_AT_KEY = 'cognito_back_at'

// A sign-in that succeeded at Cognito but is rejected right after (an API
// answers 401/403, or the token exchange fails) would bring the user back to
// /login, and Cognito would sign them in again silently — forever. Such a loop
// always goes through /login/cognito, which stamps this; merely reopening the
// console without signing in does not. Past this delay, a new redirect is a new
// attempt, such as after the JWT expired.
const LOOP_GUARD_MS = 30_000

export const markBackFromCognito = () =>
  sessionStorage.setItem(BACK_FROM_COGNITO_AT_KEY, String(Date.now()))

// A sign-out asked by the user is never a loop: the login page it ends on must
// send them to Cognito, however recently they signed in.
export const clearBackFromCognito = () => sessionStorage.removeItem(BACK_FROM_COGNITO_AT_KEY)

export const recentlyBackFromCognito = () =>
  Date.now() - Number(sessionStorage.getItem(BACK_FROM_COGNITO_AT_KEY) || 0) < LOOP_GUARD_MS

// OmniAuth only starts on a POST carrying adomik_api's CSRF token: this page of
// adomik_api submits it, and sends the user back to this console afterwards.
export const redirectToCognito = () => {
  window.location.href = `${API.COGNITO_LOGIN}?return_to=${encodeURIComponent(
    window.location.origin,
  )}`
}
